import { useState, forwardRef } from 'react'
import { useId } from '@react-aria/utils'
import styled, { useTheme } from 'styled-components'
import { css } from 'styled-components'

const StyledSelect = styled.select`
  ${props => css`
    color: ${props.theme.mainColor};
    opacity: 1;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 ${props.isFocused ? props.theme.mainColor : "#0000" });
  `}
`

function Select({
  label,
  className,
  options,
  value,
  forwardedRef,
  error,
  onBlur,
  isValid,
  isGroup,
  isFirst,
  isLast,
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false)
  const theme = useTheme();
  const id = useId(props.id)
  const errorId = useId(`error-${id}`)

  return (
    <>
      <div className="ul-relative ul-min-w-120 ul-bg-white ul-w-full">
        <label
          htmlFor={id}
          className={`ul-absolute ul-z-20 ul-left-20 ul-transform motion-safe:ul-transition-all motion-safe:ul-duration-100 ${
            !value && !options.find((o) => o.value === '')?.label.length
              ? 'ul-text-base ul-top-1/2 -ul-translate-y-1/2'
              : 'ul-text-12 ul-top-15'
          } ul-text-dark-60 ul-leading-none ul-pointer-events-none`}
        >
          {label}
        </label>
        <StyledSelect
          {...props}
          theme={theme}
          isFocused={isFocused}
          ref={forwardedRef}
          id={id}
          className={`ul-relative ul-w-full ul-bg-white ul-font-medium ul-appearance-none focus:ul-outline-none ul-px-20 ul-h-60 ul-pt-15 ${
            isFocused
              ? 'ul-ring-2 ul-z-10'
              : error
              ? 'ul-ring-2 ul-ring-danger'
              : 'ul-ring-1 ul-ring-dark-40'
          }
          ${className || ''} ${
            isGroup
              ? isFirst
                ? 'ul-rounded-l-5 ul-rounded-r-none'
                : isLast
                ? 'ul-rounded-r-5 ul-rounded-l-none'
                : ''
              : 'ul-rounded-5'
          }`}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={error ? errorId : undefined}
          value={value}
          onFocus={() => {
            setIsFocused(true)
          }}
          onBlur={(e) => {
            if (onBlur) onBlur(e)
            setIsFocused(false)
          }}
        >
          {Array.isArray(options) &&
            options.map((option) => (
              <option value={option.value} key={option.value || option.label}>
                {option.label}
              </option>
            ))}
        </StyledSelect>
        <span className="ul-text-dark-60 ul-pointer-events-none">
        </span>
      </div>
      {error ? (
        <p className="ul-text-danger ul-text-14 ul-mt-5" id={errorId}>
          {error}
        </p>
      ) : null}
    </>
  )
}

export default forwardRef(function WrappedSelect(props, ref) {
  return <Select {...props} forwardedRef={ref} />
})
